module.exports = __webpack_public_path__ + "dist/img/concat.feb041ef.webp";